import { render, staticRenderFns } from "./user-widget.vue?vue&type=template&id=5185bd4d&scoped=true&"
import script from "./user-widget.vue?vue&type=script&lang=ts&"
export * from "./user-widget.vue?vue&type=script&lang=ts&"
import style0 from "./user-widget.vue?vue&type=style&index=0&id=5185bd4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185bd4d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5185bd4d')) {
      api.createRecord('5185bd4d', component.options)
    } else {
      api.reload('5185bd4d', component.options)
    }
    module.hot.accept("./user-widget.vue?vue&type=template&id=5185bd4d&scoped=true&", function () {
      api.rerender('5185bd4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/users/components/user-widget.vue"
export default component.exports